/**
* @author Indeform Ltd
* @copyright Copyright 2020, Indeform Ltd
* @version 20200305
* @description Signing component.
*/


import Component from "../../core/component";

class Sign extends Component {
    constructor(ui, elmId, events, params = {}) {
        super(ui, elmId, events, params);

        this.elmDestination = document.body;
    }


    isStatusClassSet() {
        return this.params.statusClassName && this.ui.hasOwnProperty(this.params.statusClassName);
    }


    on_sign(data, e) {
        e.preventDefault();
        e.stopPropagation();
        this.submit(e.target.form, this.statusCheck.bind(this));

        if (this.isStatusClassSet()) {
            this.ui[this.params.statusClassName].hide();
        }
    }


    submit(form, callback = null) {
        let formData = {};
        let elm = form.elements;

        for(let i = 0, n = elm.length; i < n; i++) {
            if(elm[i].type === "checkbox" || elm[i].type === "radio") {
                if(elm[i].checked) {
                    formData[elm[i].name] = elm[i].value;
                }
            }
            else {
                formData[elm[i].name] = elm[i].value;
            }
        }

        this.core.net.post({url: form.action, data: formData, isJson: false, serialize: true})
            .then((data) => {
                try {
                    let parsedData = JSON.parse(data);
                    if (callback !== null) callback(parsedData);
                } catch (e) {
                    this.elmDestination.innerHTML = data;
                    this.ui.update();
                }
            }).catch((e) => console.log(e));
    }

    statusCheck(data) {
        let formSign = document.getElementById(this.params.elmForm);
        let status = document.getElementById(this.params.elmStatus);

        formSign.classList.add('hidden');
        status.classList.remove('hidden');

        if (this.isStatusClassSet()) {
            this.ui[this.params.statusClassName].init(data);
        }
    }
}

export { Sign }
export default Sign


//////////////////
// WEBPACK FOOTER
// ./dev_js/sso/orthosso/modules/sign/sign.js
// module id = 133
// module chunks = 0